// extracted by mini-css-extract-plugin
export default {"d-grid":"custom-buttons_d-grid__oj8jD","btn":"custom-buttons_btn__3S0nD","btn-secondary":"custom-buttons_btn-secondary__OPEv9"};